import './DateTimePicker.scss'

import { isEmbedded } from 'common/util/features'
import { format, isValid, parse } from 'date-fns'

import DateTime from 'react-datetime'
import moment from 'moment-timezone'
import React, { Component } from 'react'

const DATE_FORMAT = "YYYY-MM-DD"
const TIME_FORMAT = "HH:mm:ss"

export const DatePicker = ({ dateFormat = DATE_FORMAT, disabled, onChange, placeholder = "Select date", value }) => {
  value = value && format(parse(value), dateFormat)

  return (
    <DateTime
      className="DatePicker"
      value={value}
      inputProps={{placeholder, disabled, className: "DatePickerInput form-control"}}
      dateFormat={dateFormat}
      timeFormat={false}
      onChange={onChange}
    />
  )
}

export const TimePicker = ({ disabled, onChange, placeholder = "Select time", timeFormat = TIME_FORMAT, value }) => {
  value = value && moment.utc(value, TIME_FORMAT).local().format(timeFormat)

  return (
    <DateTime
      className="TimePicker"
      value={value}
      inputProps={{placeholder, disabled, className: "TimePickerInput form-control"}}
      dateFormat={false}
      timeFormat={timeFormat}
      onChange={onChange}
    />
  )
}

export class DateTimePicker extends Component {
  nativeOnBlur = (event) => {
    const { onDateChange, onTimeChange } = this.props
    const dateTime = event && event.target && parse(event.target.value)

    if (isValid(dateTime)) {
      onDateChange(moment(dateTime).utc().format(DATE_FORMAT))
      onTimeChange(moment(dateTime).utc().format(TIME_FORMAT))
    } else {
      onDateChange(null)
      onTimeChange(null)
    }
  }

  dateChange = date => {
    const { onDateChange } = this.props

    let value = null
    if (date) {
      try {
        value = date.format(DATE_FORMAT)
      } catch (error) {
        // Ignore bad user input
      }
    }

    onDateChange(value)
  }

  timeChange = time => {
    const { onTimeChange } = this.props

    let value = null
    if (time) {
      try {
        value = time.utc().format(TIME_FORMAT)
      } catch (error) {
        // Ignore bad user input
      }
    }

    onTimeChange(value)
  }

  render() {
    const { dateFormat, datePlaceholder, dateValue, disabled, label, timeFormat, timePlaceholder, timeValue, useNative } = this.props
    const nativePicker = isEmbedded() && useNative
    const nativeValue = (nativePicker && dateValue && timeValue) ? `${dateValue}T${timeValue}` : ''

    return (
      <div className={`DateTimePicker ${disabled ? 'DateTimePicker--disabled' : ''}`}>
        {nativePicker ? (
          <div className="NativeContainer">
            <label className="NativeDateTimeInputLabel" htmlFor="date-time-picker">{label}</label>
            <input
              id="date-time-picker"
              className="NativeDateTimeInput"
              type='datetime-local'
              onBlur={this.nativeOnBlur}
              defaultValue={nativeValue}
            />
          </div>
        ) : (
          <div className="ReactContainer">
            <DatePicker
              dateFormat={dateFormat}
              disabled={disabled}
              onChange={this.dateChange}
              placeholder={datePlaceholder}
              value={dateValue}
            />
            <TimePicker
              disabled={disabled}
              onChange={this.timeChange}
              placeholder={timePlaceholder}
              timeFormat={timeFormat}
              value={timeValue}
            />
          </div>
        )}
      </div>
    )
  }
}
